import React, { useEffect, useState, useCallback, useRef } from "react";
import Navbar from "../components/Navbar";
import Heart from "react-heart";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../Footer";
import axios from "axios";
import RateReview from "../components/RateReview";
import { FaInfoCircle } from "react-icons/fa";
import { toTitleCase } from "../helper/formatCarName";
import CarImageSlider from "../components/CarImageSlider";
import { SkeletonCard } from "../components/SkeletonLoader";

const DealerStore = () => {
  const location = useLocation();
  const navigator = useNavigate();
  const owner_id = location.state?.owner_id;

  const optionToast = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  // Dropdown refs
  const dropdownRef = useRef(null);
  const scrollRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Page state
  const [dealer, setDealer] = useState(null);
  const [totalCar, setTotalCar] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [likeStatus, setLikeStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [sortOption, setSortOption] = useState("");

  // Filter state (unified)
  const [filters, setFilters] = useState({
    minPrice: 0,
    maxPrice: 1000000,
    distance: "",
    name: "",
    model: "",
    model_varient: "",
    body_type: "",
    fuelType: [],
    gearbox: [],
    colors: [],
    minYear: "",
    maxYear: "",
    minMileage: "",
    maxMileage: "",
    engineSize: "",
  });

  // Dropdown data
  const [makeData, setMakeData] = useState([]);
  const [modelData, setModelData] = useState([]);
  const [fmodelVariantData, setModelVariantsData] = useState([]);
  const [bodTypes, setBodyTypes] = useState([]);
  const [grearBoxs, setGearBoxs] = useState([]);
  const [allColors, setAllColors] = useState([]);

  // Year / mileage / engine options
  const startYear = 2014;
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
  const mmileOptions = [];
  for (let m = 10000; m <= 250000; m += 10000) {
    mmileOptions.push({ value: m, label: `${m.toLocaleString()} km` });
  }
  mmileOptions.push({ value: 500000, label: "250,000+ km" });
  const generateOptions = () => {
    const o = [];
    for (let i = 1.1; i <= 10; i += 0.1) o.push(i.toFixed(1));
    return o;
  };

  const getDataFromlocalStorage = (key) => {
    try {
      const s = localStorage.getItem(key);
      return s ? JSON.parse(s) : null;
    } catch {
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  // Format helpers
  const formatEuroAmount = (amount) => {
    const p = amount.toString().split(".");
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return p.join(".");
  };
  const convertCcToLiters = (cc) => (cc > 0 ? (cc / 1000).toFixed(1) : 0);
  const formatNumber = (num) => {
    if (num >= 10000000) return (num / 10000000).toFixed(1) + "M";
    if (num >= 100000) return (num / 100000).toFixed(1) + "L";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num.toString();
  };
  const sortCars = (carsData, s) => {
    if (!s) return carsData;
    const sorters = {
      highest_price: (a, b) => parseFloat(b.offer_price) - parseFloat(a.offer_price),
      lowest_price: (a, b) => parseFloat(a.offer_price) - parseFloat(b.offer_price),
      mileage_high: (a, b) => b.current_mileage - a.current_mileage,
      mileage_low: (a, b) => a.current_mileage - b.current_mileage,
      recently_added: (a, b) => new Date(b.created_at) - new Date(a.created_at),
      age_newest: (a, b) => b.year - a.year,
      age_oldest: (a, b) => a.year - b.year,
    };
    return sorters[s] ? [...carsData].sort(sorters[s]) : carsData;
  };

  // API calls
  const getMake = useCallback(async () => {
    try {
      const r = await axios.get(window.CARLOCA_API + "/cars/make");
      if (r?.data?.status) setMakeData(r.data.data);
    } catch { }
  }, []);
  const getModal = useCallback(async (make) => {
    try {
      const r = await axios.post(window.CARLOCA_API + "/cars/model", { make });
      if (r?.data?.status) setModelData(r.data.data);
    } catch { }
  }, []);
  const getModalVarient = useCallback(async (model) => {
    try {
      const r = await axios.post(window.CARLOCA_API + "/cars/model-variant", { model });
      if (r?.data?.status) setModelVariantsData(r.data.data);
    } catch { }
  }, []);
  const getBodyType = useCallback(async (model) => {
    try {
      const r = await axios.post(window.CARLOCA_API + "/cars/body-type", { model });
      if (r?.data?.status) setBodyTypes(r.data.data);
    } catch { }
  }, []);
  const getGearbox = useCallback(async () => {
    try {
      const r = await axios.get(window.CARLOCA_API + "/cars/gearbox");
      if (r?.data?.status) setGearBoxs(r.data.data);
    } catch { }
  }, []);
  const getColors = useCallback(async () => {
    try {
      const r = await axios.get(window.CARLOCA_API + "/cars/colors");
      if (r?.data?.status) setAllColors(r.data.data);
    } catch { }
  }, []);
  const likeDislike = async (userId, cardId) => {
    try {
      const r = await axios.post(window.CARLOCA_API + "/like-dislike", { user_id: userId, car_id: cardId });
      if (r?.data?.status) toast.success(r.data.message, optionToast);
      else toast.error(r.data.message, optionToast);
    } catch { }
  };
  const handleLike = (cardId) => {
    if (storedUserPreferences) {
      setLikeStatus((p) => ({ ...p, [cardId]: !p[cardId] }));
      likeDislike(storedUserPreferences.id, cardId);
    } else {
      toast.warning("Please login to add favorite car!", optionToast);
    }
  };

  // Filter helpers
  const updateCheckboxFilters = (key, value, checked) =>
    setFilters((prev) => ({
      ...prev,
      [key]: checked
        ? [...(prev[key] || []), value]
        : (prev[key] || []).filter((v) => v !== value),
    }));
  const resetFilters = () =>
    setFilters({
      minPrice: 0, maxPrice: 1000000, distance: "",
      name: "", model: "", model_varient: "", body_type: "",
      fuelType: [], gearbox: [], colors: [],
      minYear: "", maxYear: "", minMileage: "", maxMileage: "", engineSize: "",
    });
  const getPriceLabel = () => {
    const min = Number(filters.minPrice), max = Number(filters.maxPrice);
    if (min > 0 && max < 1000000) return `\u00a3${formatEuroAmount(min)} \u2013 \u00a3${formatEuroAmount(max)}`;
    if (min > 0) return `From \u00a3${formatEuroAmount(min)}`;
    if (max < 1000000) return `Up to \u00a3${formatEuroAmount(max)}`;
    return "";
  };
  const activeFilterCount = [
    filters.name, filters.model, filters.model_varient, filters.body_type,
    filters.minYear, filters.maxYear, filters.maxMileage, filters.engineSize,
    filters.minPrice > 0 ? filters.minPrice : "",
    filters.maxPrice < 1000000 ? filters.maxPrice : "",
    ...(filters.fuelType || []),
    ...(filters.gearbox || []),
    ...(filters.colors || []),
  ].filter(Boolean).length;

  // Dropdown handlers
  const updateScrollArrows = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  }, []);
  const scrollChips = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "left" ? -200 : 200, behavior: "smooth" });
    setTimeout(updateScrollArrows, 350);
  };
  const toggleDropdown = (name, e) => {
    if (openDropdown === name) {
      setOpenDropdown(null);
    } else {
      const r = e.currentTarget.getBoundingClientRect();
      setDropdownPos({ top: r.bottom + 6, left: Math.max(8, Math.min(r.left, window.innerWidth - 220)) });
      setOpenDropdown(name);
    }
  };

  // Effects
  useEffect(() => {
    if (!owner_id) navigator("/");
    getMake();
    getGearbox();
    getColors();
    getBodyType(null);
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!owner_id) return;
    const id = setTimeout(async () => {
      setLoading(true);
      try {
        const payload = {
          owner_id,
          user_id: storedUserPreferences?.id || null,
          distance: filters.distance,
          min_price: filters.minPrice,
          max_price: filters.maxPrice,
          make: filters.name,
          model: filters.model,
          model_variant: filters.model_varient,
          body_type: filters.body_type,
          fuelTypeData: filters.fuelType,
          gearBoxData: filters.gearbox,
          colorData: filters.colors,
          transmission_type: filters.gearbox,
          min_mileage: filters.minMileage,
          max_mileage: filters.maxMileage,
          minyear: filters.minYear,
          maxyear: filters.maxYear,
          engine_size: filters.engineSize,
        };
        const r = await axios.post(
          window.CARLOCA_API + "/cars/dealer/search",
          payload
        );
        if (r?.data?.status) {
          const sorted = sortCars(r.data.data, sortOption);
          setDealer(r.data.dealer);
          setLikeStatus(sorted.reduce((acc, car) => ({ ...acc, [car.id]: car.isFav }), {}));
          setFilteredData(sorted);
          setTotalCar(sorted.length);
        }
      } catch (err) {
        console.error("Error fetching dealer cars:", err);
      } finally {
        setLoading(false);
      }
    }, 350);
    return () => clearTimeout(id);
  }, [owner_id, filters, sortOption]); // eslint-disable-line

  useEffect(() => {
    const h = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setOpenDropdown(null);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  useEffect(() => {
    updateScrollArrows();
    window.addEventListener("resize", updateScrollArrows);
    return () => window.removeEventListener("resize", updateScrollArrows);
  }, [updateScrollArrows]);
  // Offcanvas all-filters content
  const allFiltersContent = (
    <div className="row smallfilter">
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Make</label>
        <select className="form-select" value={filters.name} onChange={(e) => { setFilters((p) => ({ ...p, name: e.target.value })); getModal(e.target.value); }}>
          <option value="">All Makes</option>
          {makeData.map((item, i) => <option key={i} value={item?.make}>{item?.make}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Model</label>
        <select className="form-select" value={filters.model} onChange={(e) => { setFilters((p) => ({ ...p, model: e.target.value })); getModalVarient(e.target.value); getBodyType(e.target.value); }}>
          <option value="">All Models</option>
          {modelData.map((item, i) => <option key={i} value={item?.model}>{item?.model}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Variant</label>
        <select className="form-select" value={filters.model_varient} onChange={(e) => setFilters((p) => ({ ...p, model_varient: e.target.value }))}>
          <option value="">All Variants</option>
          {fmodelVariantData.map((item, i) => <option key={i} value={item?.model_varient}>{item?.model_varient}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Body Type</label>
        <select className="form-select" value={filters.body_type} onChange={(e) => setFilters((p) => ({ ...p, body_type: e.target.value }))}>
          <option value="">All Types</option>
          {bodTypes.map((item, i) => <option key={i} value={item?.body_type}>{item?.body_type}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Min Price</label>
        <select className="form-select" value={filters.minPrice} onChange={(e) => setFilters((p) => ({ ...p, minPrice: e.target.value }))}>
          <option value="0">No Min</option>
          {[5000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 200000, 300000, 400000, 500000].map(v => <option key={v} value={v}>{"\u00a3"}{formatEuroAmount(v)}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Max Price</label>
        <select className="form-select" value={filters.maxPrice} onChange={(e) => setFilters((p) => ({ ...p, maxPrice: e.target.value }))}>
          <option value="1000000">No Max</option>
          {[5000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 200000, 300000, 400000, 500000].map(v => <option key={v} value={v}>{"\u00a3"}{formatEuroAmount(v)}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Max Mileage</label>
        <select className="form-select" value={filters.maxMileage} onChange={(e) => setFilters((p) => ({ ...p, maxMileage: e.target.value }))}>
          <option value="">Any</option>
          {mmileOptions.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Distance</label>
        <select className="form-select" value={filters.distance} onChange={(e) => setFilters((p) => ({ ...p, distance: e.target.value }))}>
          <option value="">Nationwide</option>
          {[10, 20, 30, 50, 100, 200].map(d => <option key={d} value={d}>{d} miles</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Min Year</label>
        <select className="form-select" value={filters.minYear} onChange={(e) => setFilters((p) => ({ ...p, minYear: e.target.value }))}>
          <option value="">Any</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="col-6 mb-3">
        <label className="form-label fw-semibold mb-1" style={{ fontSize: "13px" }}>Max Year</label>
        <select className="form-select" value={filters.maxYear} onChange={(e) => setFilters((p) => ({ ...p, maxYear: e.target.value }))}>
          <option value="">Any</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="col-12 mb-3">
        <h6 className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Gearbox</h6>
        <div className="d-flex flex-wrap gap-2">
          {grearBoxs.map((item, i) => (
            <div key={i} className="form-check d-flex align-items-center">
              <input className="form-check-input me-1" type="checkbox"
                onChange={(e) => updateCheckboxFilters("gearbox", item?.transmission_type, e.target.checked)}
                value={item?.transmission_type} checked={filters.gearbox.includes(item?.transmission_type)} />
              <label className="form-check-label text-capitalize mb-0" style={{ fontSize: "12px" }}>{item?.transmission_type}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="col-12 mb-3">
        <h6 className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Fuel Type</h6>
        <div className="row">
          {["petrol", "diesel", "bi fuel", "elecric", "diesel hybrid", "petrol hybrid"].map((ft, i) => (
            <div key={i} className="col-6 mb-2">
              <div className="form-check d-flex align-items-center">
                <input className="form-check-input me-1" type="checkbox"
                  onChange={(e) => updateCheckboxFilters("fuelType", ft, e.target.checked)}
                  value={ft} checked={filters.fuelType.includes(ft)} />
                <label className="form-check-label text-capitalize mb-0" style={{ fontSize: "12px" }}>{ft}</label>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="col-12 mb-3">
        <h6 className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Engine Size</h6>
        <select className="form-select" value={filters.engineSize} onChange={(e) => setFilters((p) => ({ ...p, engineSize: e.target.value }))}>
          <option value="">Any</option>
          {generateOptions().map((es) => <option key={es} value={es}>{es}L</option>)}
        </select>
      </div>
      <div className="col-12 mb-3">
        <h6 className="fw-semibold mb-2" style={{ fontSize: "13px" }}>Colour</h6>
        <div className="row">
          {allColors.map((item, i) => (
            <div key={i} className="col-4 mb-2">
              <div className="form-check d-flex align-items-center">
                <input className="form-check-input me-1" type="checkbox"
                  onChange={(e) => updateCheckboxFilters("colors", item?.color, e.target.checked)}
                  value={item?.color} checked={filters.colors.includes(item?.color)} />
                <label className="form-check-label text-capitalize mb-0" style={{ fontSize: "12px" }}>{item?.color}</label>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="col-12 d-flex gap-2 mt-2">
        <button onClick={resetFilters} className="btn btn-outline-primary flex-grow-1 fw-semibold" style={{ fontSize: "13px" }}>
          <i className="fa-solid fa-rotate-right me-1"></i> Reset
        </button>
      </div>
    </div>
  );

  return (
    <>
      <Navbar />

      {/* All Filters Offcanvas */}
      <div className="offcanvas offcanvas-end" tabIndex="-1" id="dealerFiltersOffcanvas"
        aria-labelledby="dealerFiltersLabel" style={{ width: "340px", maxWidth: "90vw" }} data-bs-scroll="false">
        <div className="offcanvas-header py-3" style={{ borderBottom: "2px solid #00889c", background: "#f8fafb" }}>
          <h5 className="offcanvas-title fw-bold mb-0" id="dealerFiltersLabel" style={{ color: "#00889c", fontSize: "16px" }}>
            <i className="fa-solid fa-sliders me-2"></i>All Filters
            {activeFilterCount > 0 && (
              <span className="badge rounded-pill ms-2" style={{ backgroundColor: "#00889c", fontSize: "11px" }}>{activeFilterCount}</span>
            )}
          </h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body d-flex justify-content-center pt-3" style={{ overflowY: "auto" }}>
          {allFiltersContent}
        </div>
      </div>

      {/* Page wrapper */}
      <div className="new_page pb-4" style={{ minHeight: "100vh", paddingTop: "75px" }}>
        <div className="container-fluid px-lg-4 px-2">

          {/* Dealer hero */}
          {dealer && (
            <div className="dealer-hero-card mb-4">
              <div className="dealer-hero-top">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="dealer-hero-avatar" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 0, backgroundColor: "#fff" }}>
                    <img
                      src={dealer?.profile
                        ? `${window.CARLOCA_UPLOADS}/users/${dealer.profile}`
                        : `https://ui-avatars.com/api/?name=${dealer?.dealerName || dealer?.first_name || "D"}+${dealer?.last_name || ""}&background=random`}
                      alt={dealer?.dealerName || dealer?.first_name}
                      style={{ display: "block", margin: 0, padding: 0, objectFit: "cover" }}
                    />
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <h2 className="dealer-hero-name">
                      {dealer?.dealerName || `${dealer?.first_name || ""} ${dealer?.last_name || ""}`}
                    </h2>
                    <div className="d-flex flex-wrap gap-2 mt-1">
                      {dealer?.dealer_type && (
                        <span className="dealer-badge">
                          <i className="fa-solid fa-car me-1"></i>{dealer.dealer_type}
                        </span>
                      )}
                      <span className="dealer-badge-outline">
                        <i className="fa-solid fa-car-side me-1"></i>{totalCar} cars in stock
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap gap-2 flex-shrink-0">
                    {dealer?.phone && (
                      <a href={`tel:${dealer.phone}`} className="dealer-contact-btn">
                        <i className="fa fa-phone me-1"></i>{dealer.phone}
                      </a>
                    )}
                    {dealer?.email && (
                      <a href={`mailto:${dealer.email}`} className="dealer-contact-btn dealer-contact-btn-ghost">
                        <i className="fa-regular fa-envelope me-1"></i>Email
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="dealer-hero-info-row">
                {(dealer?.address_first || dealer?.city) && (
                  <div className="dealer-info-item">
                    <i className="fa-solid fa-location-dot"></i>
                    <span>{[dealer.address_first, dealer.address_second, dealer.city, dealer.postcode, dealer.country].filter(Boolean).join(", ")}</span>
                  </div>
                )}
                {dealer?.dealer_website && (
                  <div className="dealer-info-item">
                    <i className="fa-solid fa-globe"></i>
                    <a href={dealer.dealer_website} target="_blank" rel="noreferrer">{dealer.dealer_website}</a>
                  </div>
                )}
                <div className="dealer-info-item">
                  <i className="fa-solid fa-clock"></i>
                  <OpeningHoursDisplay dealerId={owner_id} />
                </div>
              </div>
            </div>
          )}

          {/* HF Filter Bar */}
          <div className="hf-bar" ref={dropdownRef}>
            {canScrollLeft && (
              <button className="hf-scroll-btn hf-scroll-left" onClick={() => scrollChips("left")} aria-label="Scroll left">
                <i className="fa-solid fa-chevron-left"></i>
              </button>
            )}
            <div className="hf-bar-inner" ref={scrollRef} onScroll={() => { setOpenDropdown(null); updateScrollArrows(); }}>
              {/* Make */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.name ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("make", e)}>
                  {filters.name || "Make"} <i className={`fa-solid fa-chevron-${openDropdown === "make" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "make" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="hf-dropdown-item" onClick={() => { setFilters((p) => ({ ...p, name: "" })); setOpenDropdown(null); }}>All Makes</div>
                    {makeData.map((item, i) => (
                      <div key={i} className={`hf-dropdown-item ${filters.name === item?.make ? "hf-dropdown-item-active" : ""}`}
                        onClick={() => { setFilters((p) => ({ ...p, name: item?.make })); getModal(item?.make); setOpenDropdown(null); }}>{item?.make}</div>
                    ))}
                  </div>
                )}
              </div>

              {/* Model */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.model ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("model", e)}>
                  {filters.model || "Model"} <i className={`fa-solid fa-chevron-${openDropdown === "model" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "model" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="hf-dropdown-item" onClick={() => { setFilters((p) => ({ ...p, model: "" })); setOpenDropdown(null); }}>All Models</div>
                    {modelData.map((item, i) => (
                      <div key={i} className={`hf-dropdown-item ${filters.model === item?.model ? "hf-dropdown-item-active" : ""}`}
                        onClick={() => { setFilters((p) => ({ ...p, model: item?.model })); getModalVarient(item?.model); getBodyType(item?.model); setOpenDropdown(null); }}>{item?.model}</div>
                    ))}
                  </div>
                )}
              </div>

              {/* Budget */}
              <div className="hf-item">
                <button className={`hf-chip ${getPriceLabel() ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("budget", e)}>
                  {getPriceLabel() || "Price"} <i className={`fa-solid fa-chevron-${openDropdown === "budget" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "budget" && (
                  <div className="hf-dropdown hf-dropdown-wide" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="px-3 py-2">
                      <label className="fw-semibold mb-1 d-block" style={{ fontSize: "12px", color: "#555" }}>Min Price</label>
                      <select className="form-select form-select-sm mb-2" value={filters.minPrice} onChange={(e) => setFilters((p) => ({ ...p, minPrice: e.target.value }))}>
                        <option value="0">No Min</option>
                        {[5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000, 200000, 500000].map(v => <option key={v} value={v}>{"\u00a3"}{formatEuroAmount(v)}</option>)}
                      </select>
                      <label className="fw-semibold mb-1 d-block" style={{ fontSize: "12px", color: "#555" }}>Max Price</label>
                      <select className="form-select form-select-sm" value={filters.maxPrice} onChange={(e) => setFilters((p) => ({ ...p, maxPrice: e.target.value }))}>
                        <option value="1000000">No Max</option>
                        {[5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000, 200000, 500000].map(v => <option key={v} value={v}>{"\u00a3"}{formatEuroAmount(v)}</option>)}
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* Year */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.minYear || filters.maxYear ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("year", e)}>
                  {filters.minYear && filters.maxYear ? `${filters.minYear} \u2013 ${filters.maxYear}` : filters.minYear ? `From ${filters.minYear}` : filters.maxYear ? `Up to ${filters.maxYear}` : "Year"}
                  {" "}<i className={`fa-solid fa-chevron-${openDropdown === "year" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "year" && (
                  <div className="hf-dropdown hf-dropdown-wide" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="px-3 py-2">
                      <label className="fw-semibold mb-1 d-block" style={{ fontSize: "12px", color: "#555" }}>Min Year</label>
                      <select className="form-select form-select-sm mb-2" value={filters.minYear} onChange={(e) => setFilters((p) => ({ ...p, minYear: e.target.value }))}>
                        <option value="">Any</option>
                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                      </select>
                      <label className="fw-semibold mb-1 d-block" style={{ fontSize: "12px", color: "#555" }}>Max Year</label>
                      <select className="form-select form-select-sm" value={filters.maxYear} onChange={(e) => setFilters((p) => ({ ...p, maxYear: e.target.value }))}>
                        <option value="">Any</option>
                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* Body Type */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.body_type ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("body", e)}>
                  {filters.body_type || "Body Type"} <i className={`fa-solid fa-chevron-${openDropdown === "body" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "body" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="hf-dropdown-item" onClick={() => { setFilters((p) => ({ ...p, body_type: "" })); setOpenDropdown(null); }}>All Types</div>
                    {bodTypes.map((item, i) => (
                      <div key={i} className={`hf-dropdown-item ${filters.body_type === item?.body_type ? "hf-dropdown-item-active" : ""}`}
                        onClick={() => { setFilters((p) => ({ ...p, body_type: item?.body_type })); setOpenDropdown(null); }}>{item?.body_type}</div>
                    ))}
                  </div>
                )}
              </div>

              {/* Fuel Type */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.fuelType.length > 0 ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("fuel", e)}>
                  {filters.fuelType.length > 0 ? `Fuel (${filters.fuelType.length})` : "Fuel Type"} <i className={`fa-solid fa-chevron-${openDropdown === "fuel" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "fuel" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    {["petrol", "diesel", "bi fuel", "elecric", "diesel hybrid", "petrol hybrid"].map((ft, i) => (
                      <label key={i} className="hf-dropdown-check">
                        <input type="checkbox" checked={filters.fuelType.includes(ft)} onChange={(e) => updateCheckboxFilters("fuelType", ft, e.target.checked)} />
                        <span className="text-capitalize">{ft}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Gearbox */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.gearbox.length > 0 ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("gearbox", e)}>
                  {filters.gearbox.length > 0 ? `Gearbox (${filters.gearbox.length})` : "Gearbox"} <i className={`fa-solid fa-chevron-${openDropdown === "gearbox" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "gearbox" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    {grearBoxs.map((item, i) => (
                      <label key={i} className="hf-dropdown-check">
                        <input type="checkbox" checked={filters.gearbox.includes(item?.transmission_type)} onChange={(e) => updateCheckboxFilters("gearbox", item?.transmission_type, e.target.checked)} />
                        <span className="text-capitalize">{item?.transmission_type}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Distance */}
              <div className="hf-item">
                <button className={`hf-chip ${filters.distance ? "hf-chip-active" : ""}`} onClick={(e) => toggleDropdown("distance", e)}>
                  {filters.distance ? `${filters.distance} mi` : "Distance"} <i className={`fa-solid fa-chevron-${openDropdown === "distance" ? "up" : "down"} ms-1`} style={{ fontSize: "10px" }}></i>
                </button>
                {openDropdown === "distance" && (
                  <div className="hf-dropdown" style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left, zIndex: 1060 }}>
                    <div className="hf-dropdown-item" onClick={() => { setFilters((p) => ({ ...p, distance: "" })); setOpenDropdown(null); }}>Nationwide</div>
                    {[10, 20, 30, 50, 100, 200].map(d => (
                      <div key={d} className={`hf-dropdown-item ${Number(filters.distance) === d ? "hf-dropdown-item-active" : ""}`}
                        onClick={() => { setFilters((p) => ({ ...p, distance: d })); setOpenDropdown(null); }}>{d} miles</div>
                    ))}
                  </div>
                )}
              </div>

              {/* All Filters */}
              <div className="hf-item">
                <button className="hf-chip hf-chip-all" data-bs-toggle="offcanvas" data-bs-target="#dealerFiltersOffcanvas" onClick={() => setOpenDropdown(null)}>
                  <i className="fa-solid fa-sliders me-1"></i> All Filters
                  {activeFilterCount > 0 && <span className="hf-count-badge">{activeFilterCount}</span>}
                </button>
              </div>

              {/* Reset */}
              {activeFilterCount > 0 && (
                <div className="hf-item">
                  <button className="hf-chip hf-chip-reset" onClick={resetFilters}>
                    <i className="fa-solid fa-rotate-right me-1"></i> Reset
                  </button>
                </div>
              )}
            </div>
            {canScrollRight && (
              <button className="hf-scroll-btn hf-scroll-right" onClick={() => scrollChips("right")} aria-label="Scroll right">
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            )}
          </div>

          {/* Results Header */}
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 mt-3">
            <h6 className="mb-0 fw-bold" style={{ fontSize: "15px", color: "#222" }}>
              {loading
                ? <span className="text-muted">Loading...</span>
                : filteredData.length > 0
                  ? <>{filteredData.length} car{filteredData.length !== 1 ? "s" : ""} found</>
                  : "No results"
              }
            </h6>
            <div className="d-flex align-items-center gap-2">
              <select
                className="form-select form-select-sm"
                style={{ width: "auto", minWidth: "145px", borderRadius: "8px", borderColor: "#00889c", fontSize: "13px" }}
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
              >
                <option value="">Sort by</option>
                <option value="highest_price">Highest Price</option>
                <option value="lowest_price">Lowest Price</option>
                <option value="mileage_low">Mileage Low</option>
                <option value="mileage_high">Mileage High</option>
                <option value="recently_added">Recently Added</option>
                <option value="age_newest">Newest First</option>
                <option value="age_oldest">Oldest First</option>
              </select>
              <button onClick={() => window.history.back()} className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1" style={{ borderRadius: "8px", fontSize: "13px" }}>
                <i className="fa fa-arrow-left"></i><span className="d-none d-sm-inline">Back</span>
              </button>
            </div>
          </div>

          {/* Active Filter Pills */}
          {activeFilterCount > 0 && (
            <div className="d-flex flex-wrap gap-2 mb-3">
              {filters.name && <span className="filter-pill">{filters.name}<i className="fa fa-xmark ms-1" onClick={() => setFilters((p) => ({ ...p, name: "" }))}></i></span>}
              {filters.model && <span className="filter-pill">{filters.model}<i className="fa fa-xmark ms-1" onClick={() => setFilters((p) => ({ ...p, model: "" }))}></i></span>}
              {filters.body_type && <span className="filter-pill">{filters.body_type}<i className="fa fa-xmark ms-1" onClick={() => setFilters((p) => ({ ...p, body_type: "" }))}></i></span>}
              {getPriceLabel() && <span className="filter-pill">{getPriceLabel()}<i className="fa fa-xmark ms-1" onClick={() => setFilters((p) => ({ ...p, minPrice: 0, maxPrice: 1000000 }))}></i></span>}
              {(filters.minYear || filters.maxYear) && <span className="filter-pill">{filters.minYear || "?"} {"\u2013"} {filters.maxYear || "?"}<i className="fa fa-xmark ms-1" onClick={() => setFilters((p) => ({ ...p, minYear: "", maxYear: "" }))}></i></span>}
              {filters.fuelType.map(f => <span key={f} className="filter-pill text-capitalize">{f}<i className="fa fa-xmark ms-1" onClick={() => updateCheckboxFilters("fuelType", f, false)}></i></span>)}
              {filters.gearbox.map(g => <span key={g} className="filter-pill text-capitalize">{g}<i className="fa fa-xmark ms-1" onClick={() => updateCheckboxFilters("gearbox", g, false)}></i></span>)}
              {filters.colors.map(c => <span key={c} className="filter-pill text-capitalize">{c}<i className="fa fa-xmark ms-1" onClick={() => updateCheckboxFilters("colors", c, false)}></i></span>)}
              <button className="btn btn-link p-0 text-decoration-none" style={{ color: "#00889c", fontSize: "12px", fontWeight: 600 }} onClick={resetFilters}>Clear all</button>
            </div>
          )}

          {/* Car Grid */}
          {loading ? (
            <div className="row g-3">
              <SkeletonCard count={8} />
            </div>
          ) : filteredData.length > 0 ? (
            <div className="row g-3">
              {filteredData.map((car) => (
                <div key={car.id} className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6">
                  <div
                    className="card car-result-card h-100 border-0 shadow-sm position-relative"
                    onClick={(e) => { if (!e.target.closest(".heart-icon, .dealer-link, .swiper-pagination")) navigator(`/cardetails?car=${car?.slug}`); }}
                    style={{ cursor: "pointer", borderRadius: "10px", overflow: "hidden" }}
                  >
                    <div className="car-result-img w-100" style={{ display: "flex", aspectRatio: "4/3", backgroundColor: "#111", position: "relative", overflow: "hidden" }}>
                      <CarImageSlider car={car} />
                      <div className="heart-icon" style={{ position: "absolute", top: "8px", left: "8px", zIndex: 4, height: "24px", width: "24px" }}>
                        <Heart isActive={likeStatus[car.id]} onClick={() => handleLike(car.id)}
                          animationTrigger="both" inactiveColor="rgba(255,255,255,0.9)" activeColor="#00889C" animationDuration={0.2} />
                      </div>
                      <span className="position-absolute badge" style={{ bottom: "8px", left: "8px", backgroundColor: "rgba(0,136,156,0.85)", fontSize: "11px", fontWeight: 600, borderRadius: "6px", padding: "4px 8px", zIndex: 4 }}>
                        {car.year}
                      </span>
                    </div>
                    <div className="card-body p-3">
                      <h6 className="fw-bold mb-0 text-truncate" style={{ fontSize: "14px", color: "#1a1a2e", lineHeight: 1.3 }}>
                        {toTitleCase(car.make)} {toTitleCase(car.model)}
                      </h6>
                      {car.model_varient && (
                        <p className="text-muted text-truncate mb-0" style={{ fontSize: "11px", lineHeight: 1.3 }}>{car.model_varient}</p>
                      )}
                      {car?.owner?.role !== "dealer" ? (
                        <p className="mb-2 fw-bold mt-1" style={{ color: "#00889c", fontSize: "15px", lineHeight: 1.2 }}>
                          {"\u00a3"}{formatEuroAmount(car.min_price)} <span style={{ color: "#aaa", fontWeight: 400 }}>{"\u2013"}</span> {"\u00a3"}{formatEuroAmount(car.max_price)}
                        </p>
                      ) : (
                        <p className="mb-2 fw-bold mt-1" style={{ color: "#00889c", fontSize: "15px", lineHeight: 1.2 }}>
                          {"\u00a3"}{formatEuroAmount(car.offer_price)}
                        </p>
                      )}
                      <div className="car-card-specs-grid mb-2">
                        <span className="car-spec-badge"><i className="fa-solid fa-gears me-1" style={{ color: "#00889c" }}></i>{car.transmission_type}</span>
                        <span className="car-spec-badge"><i className="fa-solid fa-road me-1" style={{ color: "#00889c" }}></i>{formatNumber(car.current_mileage)}</span>
                        <span className="car-spec-badge"><i className="fa-solid fa-gas-pump me-1" style={{ color: "#00889c" }}></i>{car.fuel_type}</span>
                        <span className="car-spec-badge"><i className="fa-solid fa-gauge-high me-1" style={{ color: "#00889c" }}></i>{convertCcToLiters(car.engine_capacity)}L</span>
                      </div>
                      <div className="car-card-footer-section">
                        {car?.owner?.city && (
                          <span className="text-muted text-capitalize" style={{ fontSize: "11px" }}>
                            <i className="fa fa-location-dot me-1"></i>{car?.owner?.city}
                          </span>
                        )}
                        <i className="fa-solid fa-chevron-right car-card-arrow ms-auto"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <div style={{ fontSize: "4rem", color: "#ccc" }}><i className="fa-solid fa-car-side"></i></div>
              <h5 className="fw-semibold mt-3" style={{ color: "#555" }}>No cars found</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>Try adjusting your filters</p>
              {activeFilterCount > 0 && (
                <button onClick={resetFilters} className="btn btn-outline-primary btn-sm mt-2" style={{ borderRadius: "8px" }}>
                  <i className="fa-solid fa-rotate-right me-1"></i> Reset Filters
                </button>
              )}
            </div>
          )}

          {/* Google Map */}
          {dealer?.latitude && dealer?.longitude && (
            <div className="row mt-4">
              <div className="col-12">
                <div className="cl-card">
                  <div className="cl-card-header">
                    <span className="fw-bold">Location</span>
                  </div>
                  <div className="cl-card-body p-0">
                    <iframe
                      title="Dealer Location"
                      src={`https://maps.google.com/maps?q=${dealer.latitude},${dealer.longitude}&hl=es;z=14&output=embed`}
                      width="100%"
                      height="380"
                      frameBorder="0"
                      style={{ border: 0, display: "block" }}
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Reviews */}
          <RateReview dealerId={owner_id} userId={storedUserPreferences?.id} />
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

// Opening Hours Component
const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

const formatTime = (timeStr) => {
  if (!timeStr) return '';
  const [hour, minute] = timeStr.split(":");
  const date = new Date();
  date.setHours(hour, minute);
  return date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const OpeningHoursDisplay = ({ dealerId }) => {
  const [openingHours, setOpeningHours] = useState([]);
  const [todayTiming, setTodayTiming] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!dealerId) return;

    axios
      .post(window.CARLOCA_API + "/get/opening-hours", {
        dealer_id: dealerId,
      })
      .then((res) => {
        const hours = daysOfWeek.map((day) => {
          const found = res.data.find((d) => d.day === day);
          return found || { day, open_time: "", close_time: "", is_closed: false };
        });
        setOpeningHours(hours);

        const todayIndex = new Date().getDay();
        const todayName = daysOfWeek[(todayIndex + 6) % 7];
        const today = hours.find((d) => d.day === todayName);
        setTodayTiming({ ...today, day: todayName });
      })
      .catch(console.error);
  }, [dealerId]);

  return (
    <div className="w-100">
      {todayTiming && (
        <div className="d-flex flex-column">
          <span className="fw-medium">
            {todayTiming.day}:{" "}
            {todayTiming.is_closed || !todayTiming.open_time || !todayTiming.close_time ? (
              <span className="text-danger">Closed</span>
            ) : (
              <span>
                {formatTime(todayTiming.open_time)} - {formatTime(todayTiming.close_time)}
              </span>
            )}
          </span>
          <span
            className="mt-1"
            style={{ cursor: "pointer", color: "#00889c", fontSize: "0.8rem" }}
            onClick={() => setShowModal(true)}
          >
            Show full week <FaInfoCircle />
          </span>
        </div>
      )}

      {showModal && (
        <div
          className="modal show fade"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Weekly Opening Hours</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <ul className="list-group">
                  {openingHours.map((hour) => (
                    <li
                      key={hour.day}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span className="fw-medium">{hour.day}</span>
                      {hour.is_closed || !hour.open_time || !hour.close_time ? (
                        <span className="badge bg-danger">Closed</span>
                      ) : (
                        <span className="text-success">
                          {formatTime(hour.open_time)} - {formatTime(hour.close_time)}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerStore;
